import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import SearchResult from "features/search-result/SearchResult";
import { useAppDispatch, useAppSelector } from "store/store";
import { fetchOfferDetails, offerListingSelector } from "./offer-listing.slice";
import Loader from "components/Loader/Loader";

interface RouteParams {
  slug: string;
}

const OfferListing: React.FC = () => {
  const { slug } = useParams<RouteParams>();
  const dispatch = useAppDispatch();
  const { offerData, loading, error, errorMessage } = useAppSelector(offerListingSelector);

  useEffect(() => {
    if (slug) {
      dispatch(fetchOfferDetails(slug));
    }
  }, [dispatch, slug]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Error Loading Offer</h2>
        <p>{errorMessage || "Failed to load offer details. Please try again later."}</p>
      </div>
    );
  }

  return <SearchResult isOfferListing={true} offerData={offerData} />;
};

export default OfferListing;
